import React, { useState } from 'react'
import InventoryMovementListing from '../../../components/InventoryMovementListing'
import {
  StringIsNullOrEmpty,
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  removeSpacewithLowerCaseString,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { PkgFeatures } from '../../../constants/StoreEntities'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const InventoryMovementReports = ({ match }) => {
  const productID = match.params.id ? match.params.id : ''

  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.AdvancedInventoryReports)) {
        setIsFeatureAllowed(false)
      }
    }
    return () => {
      mounted = false
    }
  }, [])

  return isFeatureAllowed ? (
    <div className='Content-wrapper ProductMovements-pg'>
      {!StringIsNullOrEmpty(productID) ? (
        <InventoryMovementListing
          productID={productID}
          isComponent={false}
          pageSize={10}
        />
      ) : (
        ''
      )}
    </div>
  ) : (
    <NotAllowedComponent
      getAccessLoading={false}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default InventoryMovementReports
